import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "p-15 p-md-20 border-bottom d-flex flex-wrap align-items-center justify-content-between gap-2" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2 flex-wrap" }
const _hoisted_4 = {
  key: 0,
  class: "position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger",
  style: {"font-size":"10px"}
}
const _hoisted_5 = { class: "d-flex align-items-center gap-2 flex-wrap" }
const _hoisted_6 = { class: "position-relative" }
const _hoisted_7 = {
  key: 0,
  class: "px-15 px-md-20 py-10 border-bottom d-flex flex-wrap gap-2 align-items-center"
}
const _hoisted_8 = {
  key: 0,
  class: "badge bg-primary-subtle text-primary d-flex align-items-center gap-1"
}
const _hoisted_9 = {
  key: 1,
  class: "badge bg-primary-subtle text-primary d-flex align-items-center gap-1"
}
const _hoisted_10 = {
  key: 2,
  class: "badge bg-primary-subtle text-primary d-flex align-items-center gap-1"
}
const _hoisted_11 = {
  key: 3,
  class: "badge bg-primary-subtle text-primary d-flex align-items-center gap-1"
}
const _hoisted_12 = {
  key: 4,
  class: "badge bg-primary-subtle text-primary d-flex align-items-center gap-1"
}
const _hoisted_13 = {
  key: 5,
  class: "badge bg-primary-subtle text-primary d-flex align-items-center gap-1"
}
const _hoisted_14 = {
  key: 6,
  class: "badge bg-primary-subtle text-primary d-flex align-items-center gap-1"
}
const _hoisted_15 = { class: "border-bottom bg-light px-15 px-md-20 py-15" }
const _hoisted_16 = { class: "row g-3 align-items-end" }
const _hoisted_17 = { class: "col-sm-6 col-lg-4" }
const _hoisted_18 = { class: "col-sm-6 col-lg-4" }
const _hoisted_19 = { class: "col-sm-6 col-lg-4" }
const _hoisted_20 = { class: "col-sm-6 col-lg-4" }
const _hoisted_21 = { class: "col-sm-6 col-lg-4" }
const _hoisted_22 = {
  class: "position-absolute mt-1 p-2 bg-white shadow rounded",
  style: {"z-index":"999"}
}
const _hoisted_23 = { class: "d-flex gap-2 mt-15 pt-10 border-top" }
const _hoisted_24 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_25 = { class: "table-responsive" }
const _hoisted_26 = {
  class: "table text-nowrap align-middle mb-0",
  style: {"min-width":"900px"}
}
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_30 = {
  key: 1,
  class: "text-info"
}
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_33 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_34 = { class: "text-nowrap" }
const _hoisted_35 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_38 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_39 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_40 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_41 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_42 = { class: "d-block text-muted fs-12" }
const _hoisted_43 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_44 = { class: "dropdown" }
const _hoisted_45 = { class: "dropdown-menu" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { key: 0 }
const _hoisted_49 = ["href"]
const _hoisted_50 = ["href"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { key: 1 }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { key: 2 }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { class: "d-flex flex-wrap align-items-center justify-content-between gap-3 mt-20 pt-15 border-top" }
const _hoisted_57 = { class: "d-flex align-items-center gap-2" }
const _hoisted_58 = { class: "mb-0 text-muted small" }
const _hoisted_59 = { class: "fw-semibold text-dark" }
const _hoisted_60 = { class: "fw-semibold text-dark" }
const _hoisted_61 = { class: "fw-semibold text-dark" }
const _hoisted_62 = { "aria-label": "Pagination" }
const _hoisted_63 = { class: "pagination pagination-sm mb-0 gap-1" }
const _hoisted_64 = {
  key: 0,
  class: "page-item disabled"
}
const _hoisted_65 = ["onClick"]
const _hoisted_66 = {
  class: "modal fade",
  id: "modal_update_status",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_67 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_68 = { class: "modal-content p-15 p-md-40" }
const _hoisted_69 = { class: "modal-body" }
const _hoisted_70 = { class: "mb-3" }
const _hoisted_71 = { class: "mb-3" }
const _hoisted_72 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_73 = ["min"]
const _hoisted_74 = { class: "modal-footer" }
const _hoisted_75 = {
  class: "modal fade",
  id: "modal_detail_suivi",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_76 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_77 = { class: "modal-content p-15 p-md-40" }
const _hoisted_78 = { class: "modal-body" }
const _hoisted_79 = {
  class: "modal fade",
  id: "modal_detail_colis",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_80 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_81 = { class: "modal-content p-15 p-md-40" }
const _hoisted_82 = { class: "modal-body" }
const _hoisted_83 = {
  class: "modal fade",
  id: "modal_update",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_84 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_85 = { class: "modal-content p-15 p-md-40" }
const _hoisted_86 = { class: "modal-body" }
const _hoisted_87 = {
  class: "modal fade",
  id: "modalExortToday",
  tabindex: "-1",
  ref: "reportedModal"
}
const _hoisted_88 = { class: "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_89 = { class: "modal-content" }
const _hoisted_90 = { class: "modal-body" }
const _hoisted_91 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_92 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_93 = { class: "table table-bordered table-striped" }
const _hoisted_94 = {
  key: 2,
  class: "text-center text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_MyDateRangePicker = _resolveComponent("MyDateRangePicker")!
  const _component_HistoryColis = _resolveComponent("HistoryColis")!
  const _component_DetailsColis = _resolveComponent("DetailsColis")!
  const _component_UpdateParcel = _resolveComponent("UpdateParcel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[32] || (_cache[32] = _createElementVNode("h6", { class: "mb-0 fw-bold" }, "Liste des colis", -1)),
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-primary position-relative",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filtersOpen = !_ctx.filtersOpen))
          }, [
            _cache[29] || (_cache[29] = _createElementVNode("i", { class: "flaticon-filter me-1" }, null, -1)),
            _cache[30] || (_cache[30] = _createTextVNode(" Filtres ", -1)),
            (_ctx.activeFilterCount > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.activeFilterCount), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.activeFilterCount > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-sm btn-outline-secondary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
              }, _cache[31] || (_cache[31] = [
                _createElementVNode("i", { class: "flaticon-close me-1" }, null, -1),
                _createTextVNode(" Réinitialiser ", -1)
              ])))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[33] || (_cache[33] = _createElementVNode("i", {
              class: "flaticon-search position-absolute top-50 translate-middle-y",
              style: {"left":"10px","opacity":"0.4","pointer-events":"none"}
            }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm rounded-1",
              style: {"min-width":"240px","padding-left":"32px"},
              placeholder: "Code, téléphone, destinataire...",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ])
          ]),
          (_ctx.auth.can('EXPORT_PARCELS'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-sm btn-outline-success",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.exportColis && _ctx.exportColis(...args)))
              }, _cache[34] || (_cache[34] = [
                _createElementVNode("i", { class: "flaticon-file-1 me-1" }, null, -1),
                _createTextVNode(" Export ", -1)
              ])))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.activeFilterCount > 0 && !_ctx.filtersOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[35] || (_cache[35] = _createElementVNode("span", { class: "text-muted fs-13 me-1" }, "Filtres actifs :", -1)),
            (_ctx.client_filter?.name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.client_filter.name) + " ", 1),
                  _createElementVNode("i", {
                    class: "ph ph-x",
                    style: {"cursor":"pointer"},
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.removeOneFilter('client')))
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.zone_filter?.name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_ctx.zone_filter.name) + " ", 1),
                  _createElementVNode("i", {
                    class: "ph ph-x",
                    style: {"cursor":"pointer"},
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.removeOneFilter('zone')))
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.city_filter?.name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.city_filter.name) + " ", 1),
                  _createElementVNode("i", {
                    class: "ph ph-x",
                    style: {"cursor":"pointer"},
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.removeOneFilter('city')))
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.liv_filter?.name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                  _createTextVNode(_toDisplayString(_ctx.liv_filter.name) + " ", 1),
                  _createElementVNode("i", {
                    class: "ph ph-x",
                    style: {"cursor":"pointer"},
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.removeOneFilter('liv')))
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.etat_filter)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.etat_filter) + " ", 1),
                  _createElementVNode("i", {
                    class: "ph ph-x",
                    style: {"cursor":"pointer"},
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.removeOneFilter('etat')))
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.status_filter?.name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  _createTextVNode(_toDisplayString(_ctx.status_filter.name) + " ", 1),
                  _createElementVNode("i", {
                    class: "ph ph-x",
                    style: {"cursor":"pointer"},
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.removeOneFilter('status')))
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.date_from)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                  _createTextVNode(_toDisplayString(_ctx.date_from) + " – " + _toDisplayString(_ctx.date_to || "...") + " ", 1),
                  _createElementVNode("i", {
                    class: "ph ph-x",
                    style: {"cursor":"pointer"},
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.removeOneFilter('date')))
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[36] || (_cache[36] = _createElementVNode("label", { class: "form-label fw-medium fs-13 mb-1" }, "Magasin", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.client_filter,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.client_filter) = $event)),
              label: "name",
              options: _ctx.clientList,
              onSearch: _ctx.filterClients,
              placeholder: "Tous"
            }, null, 8, ["modelValue", "options", "onSearch"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[37] || (_cache[37] = _createElementVNode("label", { class: "form-label fw-medium fs-13 mb-1" }, "Ville", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.city_filter,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.city_filter) = $event)),
              label: "name",
              options: _ctx.citiesList,
              placeholder: "Toutes"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[38] || (_cache[38] = _createElementVNode("label", { class: "form-label fw-medium fs-13 mb-1" }, "État", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.etat_filter,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.etat_filter) = $event)),
              label: "name",
              options: _ctx.etatList,
              placeholder: "Tous"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[39] || (_cache[39] = _createElementVNode("label", { class: "form-label fw-medium fs-13 mb-1" }, "Status", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.status_filter,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.status_filter) = $event)),
              label: "name",
              options: _ctx.status,
              placeholder: "Tous"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[41] || (_cache[41] = _createElementVNode("label", { class: "form-label fw-medium fs-13 mb-1" }, "Période", -1)),
            _createElementVNode("div", {
              class: "form-control form-control-sm d-flex align-items-center justify-content-between",
              style: {"cursor":"pointer"},
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showCalendar()))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.selectedDate?.[0]?.format("DD MMM YYYY") || "Date début") + " – " + _toDisplayString(_ctx.selectedDate?.[1]?.format("DD MMM YYYY") || "Date fin"), 1),
              _cache[40] || (_cache[40] = _createElementVNode("i", { class: "flaticon-calendar" }, null, -1))
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_22, [
              _createVNode(_component_MyDateRangePicker, {
                modelValue: _ctx.selectedDate,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selectedDate) = $event)),
                onOnSelect: _ctx.showCalendar,
                enableSecondCalendar: true
              }, null, 8, ["modelValue", "onOnSelect"])
            ], 512), [
              [_vShow, _ctx.showCalendarBox]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", {
            class: "btn btn-primary btn-sm px-4",
            onClick: _cache[18] || (_cache[18] = ($event: any) => {_ctx.applyFilters(); _ctx.filtersOpen = false})
          }, _cache[42] || (_cache[42] = [
            _createElementVNode("i", { class: "flaticon-filter me-1" }, null, -1),
            _createTextVNode(" Appliquer ", -1)
          ])),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary btn-sm px-4",
            onClick: _cache[19] || (_cache[19] = ($event: any) => {_ctx.resetFilters(); _ctx.filtersOpen = false})
          }, _cache[43] || (_cache[43] = [
            _createElementVNode("i", { class: "flaticon-close me-1" }, null, -1),
            _createTextVNode(" Réinitialiser ", -1)
          ])),
          _createElementVNode("button", {
            class: "btn btn-link btn-sm text-muted ms-auto",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.filtersOpen = false))
          }, " Fermer ")
        ])
      ], 512), [
        [_vShow, _ctx.filtersOpen]
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("table", _hoisted_26, [
            _cache[65] || (_cache[65] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                }, " Code d'envoi "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Dernière mise à jour "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Destinataire "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Magasin "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Etat "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Status "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Ville "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Prix "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " ACTIONS ")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("th", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      (row.replace === 1)
                        ? (_openBlock(), _createElementBlock("h6", _hoisted_29, [
                            _createTextVNode(_toDisplayString(row.code) + " ", 1),
                            _cache[44] || (_cache[44] = _createElementVNode("i", { class: "ph ph-repeat" }, null, -1))
                          ]))
                        : (row.partial === 1)
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_30, [
                              _createTextVNode(_toDisplayString(row.code) + " ", 1),
                              _cache[45] || (_cache[45] = _createElementVNode("i", { class: "ph ph-arrows-down-up" }, null, -1))
                            ]))
                          : (_openBlock(), _createElementBlock("h6", _hoisted_31, _toDisplayString(row.code), 1))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.getDate(row.updated_at)), 1),
                  _createElementVNode("td", _hoisted_33, [
                    _createElementVNode("p", _hoisted_34, [
                      _createElementVNode("b", null, _toDisplayString(row.receiver), 1),
                      _cache[46] || (_cache[46] = _createTextVNode()),
                      _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("b", null, _toDisplayString(_ctx.oldPhone(row.phone)), 1),
                      _cache[48] || (_cache[48] = _createTextVNode()),
                      _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_35, [
                    (row.magasin_name)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_36, _toDisplayString(row.magasin_name), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(" " + _toDisplayString(row.customer_name), 1),
                          _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.oldPhone(row.customer_phone)), 1)
                        ]))
                  ]),
                  _createElementVNode("td", _hoisted_38, [
                    _createElementVNode("span", {
                      class: _normalizeClass(`badge text-outline-${_ctx.resolveUserStatusVariant(
                    row.situation
                  )}`)
                    }, _toDisplayString(_ctx.resolveStatuParcel(row.situation)), 3)
                  ]),
                  _createElementVNode("td", _hoisted_39, [
                    (
                    row.status == 'IN_PROGRESS' &&
                    row.status_second &&
                    _ctx.globalHelper(row.status_second)?.name
                  )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({
                    '--dynamic-bg': _ctx.globalHelper(row.status_second)?.code_color,
                  })
                        }, [
                          (
                      row.status_second == 'POSTPONED' ||
                      row.status_second == 'PROGRAMED'
                    )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.globalHelper(row.status_second)?.name) + " ", 1),
                                _cache[52] || (_cache[52] = _createElementVNode("br", null, null, -1)),
                                _createTextVNode(" " + _toDisplayString(row.reported_date), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.globalHelper(row.status_second)?.name), 1)
                              ], 64))
                        ], 4))
                      : (
                    row.status == 'RETURNED' &&
                    (!row.status_second || row.status_second != 'REFUSE') &&
                    row.last_statut_comment
                  )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                            style: _normalizeStyle({ '--dynamic-bg': row.code_color })
                          }, [
                            _createTextVNode(_toDisplayString(row.s_name), 1),
                            _cache[53] || (_cache[53] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(" - " + _toDisplayString(row.last_statut_comment), 1)
                          ], 4))
                        : (
                    row.status == 'RETURNED' &&
                    row.status_second == 'REFUSE' &&
                    _ctx.globalHelper(row.status_second)?.name
                  )
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                              style: _normalizeStyle({
                    '--dynamic-bg': _ctx.globalHelper(row.status_second)?.code_color,
                  })
                            }, " Retourné - " + _toDisplayString(_ctx.globalHelper(row.status_second)?.name), 5))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 3,
                              class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                              style: _normalizeStyle({ '--dynamic-bg': row.code_color })
                            }, _toDisplayString(row.s_name), 5))
                  ]),
                  _createElementVNode("td", _hoisted_40, [
                    _createElementVNode("b", null, _toDisplayString(row.city_name), 1),
                    _cache[54] || (_cache[54] = _createElementVNode("br", null, null, -1))
                  ]),
                  _createElementVNode("td", _hoisted_41, [
                    _createElementVNode("b", null, _toDisplayString(row.price), 1),
                    _cache[55] || (_cache[55] = _createTextVNode("Dhs", -1)),
                    _cache[56] || (_cache[56] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("span", _hoisted_42, _toDisplayString(row.product_nature), 1)
                  ]),
                  _createElementVNode("td", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _cache[64] || (_cache[64] = _createElementVNode("button", {
                        class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                        type: "button",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, [
                        _createElementVNode("i", { class: "flaticon-dots" })
                      ], -1)),
                      _createElementVNode("ul", _hoisted_45, [
                        _createElementVNode("li", null, [
                          _createElementVNode("button", {
                            class: "dropdown-item d-flex align-items-center",
                            onClick: ($event: any) => (_ctx.showDetailSuivi(row))
                          }, _cache[57] || (_cache[57] = [
                            _createElementVNode("i", { class: "flaticon-clock lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Historique ", -1)
                          ]), 8, _hoisted_46)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("button", {
                            class: "dropdown-item d-flex align-items-center",
                            onClick: ($event: any) => (_ctx.showDetails(row))
                          }, _cache[58] || (_cache[58] = [
                            _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Détails ", -1)
                          ]), 8, _hoisted_47)
                        ]),
                        (
                        row.status == 'DISTRIBUTION' ||
                        (row.status == 'IN_PROGRESS' && row.invoiced == 0)
                      )
                          ? (_openBlock(), _createElementBlock("li", _hoisted_48, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: `tel:` + _ctx.SubstrPhone(row.phone)
                              }, _cache[59] || (_cache[59] = [
                                _createElementVNode("i", { class: "flaticon-phone-call" }, null, -1),
                                _createTextVNode(" Appeler Destinataire ", -1)
                              ]), 8, _hoisted_49)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            target: "_blank",
                            href: `https://api.whatsapp.com/send?phone=${_ctx.SubstrPhone(
                          row.phone
                        )}&text=Client : ${row.customer_name} Téléphone : ${
                          row.customer_phone
                        } Code d'envoi : ${row.code} Destinataire : ${
                          row.receiver
                        } Téléphone : ${row.phone} Ville : ${
                          row.city_name
                        } Adresse : ${row.address} Commentaire : ${
                          row.note
                        } Produit : ${row.product_nature} Crbt : ${
                          row.price
                        } DH`
                          }, _cache[60] || (_cache[60] = [
                            _createElementVNode("i", { class: "ph ph-whatsapp-logo lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" WhatsApp ", -1)
                          ]), 8, _hoisted_50)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.ShareCust(row))
                          }, _cache[61] || (_cache[61] = [
                            _createElementVNode("i", { class: "flaticon-send lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Partager avec vendeur ", -1)
                          ]), 8, _hoisted_51)
                        ]),
                        (
                        _ctx.auth.can('PARCELS') &&
                        _ctx.user?.role_id === 3 &&
                        row.status !== 'NEW_PARCEL' &&
                        row.status !== 'WAITING_PICKUP' &&
                        row.status !== 'RETURNED' &&
                        row.status !== 'RETURNED_PARTIAL'
                      )
                          ? (_openBlock(), _createElementBlock("li", _hoisted_52, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.showUpdate(row))
                              }, _cache[62] || (_cache[62] = [
                                _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Modifier ", -1)
                              ]), 8, _hoisted_53)
                            ]))
                          : _createCommentVNode("", true),
                        (
                        row.status === 'DISTRIBUTION' ||
                        (row.status === 'IN_PROGRESS' && row.invoiced === 0)
                      )
                          ? (_openBlock(), _createElementBlock("li", _hoisted_54, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.showStatus(row.id))
                              }, _cache[63] || (_cache[63] = [
                                _createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Changer Status ", -1)
                              ]), 8, _hoisted_55)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _cache[67] || (_cache[67] = _createElementVNode("span", { class: "text-muted small" }, "Afficher", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm w-auto",
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.filter.per_page) = $event)),
              onChange: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.changePerPage && _ctx.changePerPage(...args)))
            }, _cache[66] || (_cache[66] = [
              _createElementVNode("option", { value: 10 }, "10", -1),
              _createElementVNode("option", { value: 50 }, "50", -1),
              _createElementVNode("option", { value: 100 }, "100", -1),
              _createElementVNode("option", { value: 500 }, "500", -1)
            ]), 544), [
              [_vModelSelect, _ctx.filter.per_page]
            ]),
            _cache[68] || (_cache[68] = _createElementVNode("span", { class: "text-muted small" }, "lignes", -1))
          ]),
          _createElementVNode("p", _hoisted_58, [
            _createElementVNode("span", _hoisted_59, _toDisplayString((_ctx.filter.current_page - 1) * _ctx.filter.per_page + 1), 1),
            _cache[69] || (_cache[69] = _createTextVNode(" – ", -1)),
            _createElementVNode("span", _hoisted_60, _toDisplayString(Math.min(_ctx.filter.current_page * _ctx.filter.per_page, _ctx.filter.total)), 1),
            _cache[70] || (_cache[70] = _createTextVNode(" sur ", -1)),
            _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.filter.total), 1),
            _cache[71] || (_cache[71] = _createTextVNode(" résultats ", -1))
          ]),
          _createElementVNode("nav", _hoisted_62, [
            _createElementVNode("ul", _hoisted_63, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.filter.current_page === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link rounded-1",
                  href: "javascript:void(0)",
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.goToPage(_ctx.filter.current_page - 1))),
                  "aria-label": "Précédent"
                }, _cache[72] || (_cache[72] = [
                  _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                ]))
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedPages, (page, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  (page === '...')
                    ? (_openBlock(), _createElementBlock("li", _hoisted_64, _cache[73] || (_cache[73] = [
                        _createElementVNode("span", { class: "page-link rounded-1 border-0 bg-transparent" }, "…", -1)
                      ])))
                    : (_openBlock(), _createElementBlock("li", {
                        key: 1,
                        class: _normalizeClass(["page-item", { active: _ctx.filter.current_page === page }])
                      }, [
                        _createElementVNode("a", {
                          href: "javascript:void(0)",
                          class: "page-link rounded-1",
                          onClick: ($event: any) => (_ctx.goToPage(page as number))
                        }, _toDisplayString(page), 9, _hoisted_65)
                      ], 2))
                ], 64))
              }), 128)),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.filter.current_page === _ctx.filter.last_page }])
              }, [
                _createElementVNode("a", {
                  class: "page-link rounded-1",
                  href: "javascript:void(0)",
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.goToPage(_ctx.filter.current_page + 1))),
                  "aria-label": "Suivant"
                }, _cache[74] || (_cache[74] = [
                  _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                ]))
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_66, [
      _createElementVNode("div", _hoisted_67, [
        _createElementVNode("div", _hoisted_68, [
          _cache[78] || (_cache[78] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Changer le statut du colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_70, [
                _cache[75] || (_cache[75] = _createElementVNode("label", {
                  for: "statut",
                  class: "form-label"
                }, "Statut", -1)),
                _createVNode(_component_v_select, {
                  class: "custom-select-height",
                  id: "statut",
                  modelValue: _ctx.statutColi,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.statutColi) = $event)),
                  label: "name",
                  placeholder: "Choisir un statut",
                  options: _ctx.statusList
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_71, [
                _cache[76] || (_cache[76] = _createElementVNode("label", {
                  for: "note",
                  class: "form-label"
                }, "Commentaire", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.commentStatu) = $event)),
                  name: "note",
                  rows: "3",
                  class: "form-control",
                  placeholder: "Écrire un commentaire ici..."
                }, null, 512), [
                  [_vModelText, _ctx.commentStatu]
                ])
              ]),
              (
                _ctx.statutColi.code === 'POSTPONED' ||
                _ctx.statutColi.code === 'PROGRAMED'
              )
                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    _cache[77] || (_cache[77] = _createElementVNode("label", {
                      for: "datepicker-dateformat2",
                      class: "form-label"
                    }, "Date le :", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      id: "datepicker-dateformat2",
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.date_retour) = $event)),
                      class: "form-control",
                      min: _ctx.minDate
                    }, null, 8, _hoisted_73), [
                      [_vModelText, _ctx.date_retour]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_74, [
            (_ctx.auth.can('PARCELS'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.editPriceStatut && _ctx.editPriceStatut(...args)))
                }, " Enregistrer "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_75, [
      _createElementVNode("div", _hoisted_76, [
        _createElementVNode("div", _hoisted_77, [
          _cache[79] || (_cache[79] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Historique Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_78, [
            (_ctx.colisId)
              ? (_openBlock(), _createBlock(_component_HistoryColis, {
                  key: 0,
                  colisId: _ctx.colisId,
                  isOpen: _ctx.isOpen,
                  status: _ctx.status
                }, null, 8, ["colisId", "isOpen", "status"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_79, [
      _createElementVNode("div", _hoisted_80, [
        _createElementVNode("div", _hoisted_81, [
          _cache[80] || (_cache[80] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Détails Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_82, [
            (_ctx.coliDetails)
              ? (_openBlock(), _createBlock(_component_DetailsColis, {
                  key: 0,
                  coliDetails: _ctx.coliDetails,
                  isOpen: _ctx.isOpen
                }, null, 8, ["coliDetails", "isOpen"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_83, [
      _createElementVNode("div", _hoisted_84, [
        _createElementVNode("div", _hoisted_85, [
          _cache[81] || (_cache[81] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Modifier Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_86, [
            (_ctx.rowUpdate)
              ? (_openBlock(), _createBlock(_component_UpdateParcel, {
                  key: 0,
                  rowColis: _ctx.rowUpdate,
                  getRecords: _ctx.getRecords,
                  isOpenEdit: _ctx.isOpenEdit,
                  hideModal: _ctx.hideModal
                }, null, 8, ["rowColis", "getRecords", "isOpenEdit", "hideModal"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_87, [
      _createElementVNode("div", _hoisted_88, [
        _createElementVNode("div", _hoisted_89, [
          _cache[84] || (_cache[84] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Colis reportés aujourd’hui"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_90, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_91, _cache[82] || (_cache[82] = [
                  _createElementVNode("div", { class: "spinner-border text-warning" }, null, -1),
                  _createElementVNode("p", { class: "mt-2" }, "Chargement...", -1)
                ])))
              : (_ctx.parcels.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                    _createElementVNode("table", _hoisted_93, [
                      _cache[83] || (_cache[83] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Code"),
                          _createElementVNode("th", null, "Client"),
                          _createElementVNode("th", null, "Destinataire"),
                          _createElementVNode("th", null, "Téléphone"),
                          _createElementVNode("th", null, "Ville"),
                          _createElementVNode("th", null, "Prix"),
                          _createElementVNode("th", null, "Date report")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parcels, (item) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(item.code), 1),
                            _createElementVNode("td", null, _toDisplayString(item.store ?? "-"), 1),
                            _createElementVNode("td", null, _toDisplayString(item.receiver), 1),
                            _createElementVNode("td", null, _toDisplayString(item.phone), 1),
                            _createElementVNode("td", null, _toDisplayString(item.city_name), 1),
                            _createElementVNode("td", null, _toDisplayString(item.price) + " DH", 1),
                            _createElementVNode("td", null, _toDisplayString(item.reported_date), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_94, "Aucun colis trouvé."))
          ])
        ])
      ])
    ], 512)
  ], 64))
}